import { useWorkInfoStore } from './useWorkInfoStore';

export { useWorkInfoStore };

const workInfoStore = { useWorkInfoStore };

export default workInfoStore;
